'use strict';
const createWidgetFactory = require('components-framework/widget/create_widget_factory');
const modelClass = require('./model');
const viewClass = require('./view');

module.exports = createWidgetFactory({
    name: 'intermediate_layer_manager',
    modelClass,
    viewClass,
    methods: {
        renderCancellations(cancellationCards) {
            this.renderCancellations(cancellationCards);
        },
        displayCancellationsWithType(type, trackingInfo) {
            this.displayCancellationsWithType(type, trackingInfo);
        },
    },
});
